import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const ReferralRedirect = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (process.env.REACT_APP_DEV_ENV === "false") {
      const storeReferralInfo = () => {
        const fullUrl = window.location.href
        const pathOnly = fullUrl.split(window.location.origin + "/")[1]

        localStorage.setItem("leadDyno_fullReferralUrl", fullUrl)
        localStorage.setItem("leadDyno_fullReferralPath", pathOnly)
      }

      const searchParams = new URLSearchParams(location.search)
      const hasAffiliateParam = searchParams.has("afmc")

      if (hasAffiliateParam) {
        storeReferralInfo()
        navigate(
          {
            pathname: "/",
            search: location.search,
          },
          { replace: true }
        )
      } else {
        navigate("/404", { replace: true })
      }
    } else {
      // In dev environment, also navigate to 404 for non-affiliate URLs
      const searchParams = new URLSearchParams(location.search)
      const hasAffiliateParam = searchParams.has("afmc")
      
      if (!hasAffiliateParam) {
        navigate("/404", { replace: true })
      }
    }
  }, [])

  return null
}

export default ReferralRedirect
